import React from 'react'

import { useSurveyQueryCustomerAttributeGroups } from '~/hooks/useSurveyQuery'

export const useAvailableCustomerAttributeGroups = () => {
  const customerAttributeGroups = useSurveyQueryCustomerAttributeGroups()

  return React.useMemo(
    () =>
      customerAttributeGroups.filter(
        (customerAttributeGroup) =>
          0 < customerAttributeGroup.customerAttributes.length,
      ),
    [customerAttributeGroups],
  )
}
